import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import GlobalPinHandler from './components/GlobalPinHandler';
import KioskSessionManager from './components/KioskSessionManager';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <KioskSessionManager />
      <GlobalPinHandler />
      <PWAInstallPrompt />
    </BrowserRouter>
  );
}

export default App;
